import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const containerVariant = {
  hidden: {
    x: '100vw',
    opacity: 0
  },
  animate: {
    x: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      mass: 0.4,
      damping: 8,
      when: 'beforeChildren',
      staggerChildren: 0.2
    }
  }
}

const childVariant = {
  hidden: {
    opacity: 0
  },
  animate: {
    opacity: 1
  }
}

const Order = ({ pizza, showModal }) => {

  useEffect(() => {
    setTimeout(() => showModal(true), 5000);
  }, [showModal]);


  return (
    <motion.div className="container order"
      variants={containerVariant}
      initial="hidden"
      animate="animate"
    >
      <h2>Thank you for your order :)</h2>
      <motion.p variants={childVariant}>You ordered a {pizza.base} pizza with:</motion.p>
      {pizza.toppings.length > 0 ? pizza.toppings.map(topping => <motion.div variants={childVariant} key={topping}>{topping}</motion.div>)
        : <motion.div variants={childVariant} >No toppings</motion.div>}
    </motion.div>
  )
}

export default Order;